<ngb-pagination *ngIf="collectionSize > pageSize"
                [(page)]="currentPage"
                [collectionSize]="collectionSize"
                [pageSize]="pageSize"
                [maxSize]="maxSize"
                [boundaryLinks]="true"
                [rotate]="true"
                (pageChange)="onPageChange($event)">
</ngb-pagination>
